import React from "react";
import { Link } from "react-router-dom";
// reactstrap components
import {
  Collapse,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
  UncontrolledTooltip,
  Button
} from "reactstrap";

function ExamplesNavbar(props) {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [productos, setProductos] = React.useState([{ name: "Producto1" }, { name: "Producto2" }])

  const handleClick = (event, view, product) => {
    props.onChange("view", view, product);
  }
  const handleClick2 = () => {
    props.onChange("user", {});
    props.onChange("view", "index");
    props.onChange("userstatus", false);
    props.onChange("admin", false);

  }

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 399 ||
        document.body.scrollTop > 399
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 400 ||
        document.body.scrollTop < 400
      ) {
        setNavbarColor("navbar-transparent");
      }
    };
    window.addEventListener("scroll", updateNavbarColor);
    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });

  const handleClick3 = (event, product) => {
    props.onChange("services", product);
  }
  return (
    <>
      {collapseOpen ? (
        <div
          id="bodyClick"
          onClick={() => {
            document.documentElement.classList.toggle("nav-open");
            setCollapseOpen(false);
          }}
        />
      ) : null}
      <Navbar className={"fixed-top " + navbarColor} color="info" expand="lg">
        <Container>

          <div className="navbar-translate">
            <NavbarBrand
              onClick={event => handleClick(event, "index")}
              id="navbar-brand"
            >
              <img
                style={{ width: "85px", height: "50px" }}
                alt="..."
                className="n-logo"
                src={require("assets/img/logosinfondo.png")}
              ></img>
            </NavbarBrand>
            <button
              className="navbar-toggler navbar-toggler"
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(!collapseOpen);
              }}
              aria-expanded={collapseOpen}
              type="button"
            >
              <span className="navbar-toggler-bar top-bar"></span>
              <span className="navbar-toggler-bar middle-bar"></span>
              <span className="navbar-toggler-bar bottom-bar"></span>
            </button>
          </div>
          <Collapse
            className="justify-content-end"
            isOpen={collapseOpen}
            navbar
          >
            <Nav navbar>
              <NavItem>
                <NavLink
                  onClick={event => handleClick(event, "info")}
                >
                  <i className="now-ui-icons education_atom"></i>
                  <p style={{ fontSize: "18px" }}>Conócenos</p>
                </NavLink>
              </NavItem>
              <UncontrolledDropdown nav>
                <DropdownToggle
                  caret
                  color="default"
                  nav
                >
                  <i className="now-ui-icons shopping_bag-16"></i>
                  <p style={{ fontSize: "18px" }}>Productos/Servicios</p>
                </DropdownToggle>
                <DropdownMenu>
                  {productos.map(option => (
                    <DropdownItem onClick={event => handleClick3(event, option)} tag={Link}>
                      <i className="now-ui-icons business_chart-pie-36 mr-1"></i>
                      <p style={{ fontSize: "18px" }}>{option.name}</p>
                    </DropdownItem>
                  ))}

                </DropdownMenu>
              </UncontrolledDropdown>
              {/*
                <NavItem>
                <Button
                  className="nav-link btn-neutral"
                  color="info"
                  id="upgrade-to-pro"
                  onClick={event => handleClick(event, "contact")}
                >
                  <i className="now-ui-icons arrows-1_share-66 mr-1"></i>
                  <p style={{ fontSize: "18px" }}>Contáctanos</p>
                </Button>
                <UncontrolledTooltip target="#upgrade-to-pro">
                  ¡Contáctanos!
                </UncontrolledTooltip>
              </NavItem>
            */}
              {props.userstatus == false ?
                <>
                  <NavItem>
                    <NavLink
                      onClick={event => handleClick(event, "login")}
                      id="login-tooltip"
                    >
                      <i className="now-ui-icons users_circle-08"></i>
                      <p className="d-lg-none d-xl-none">Inicia sesión</p>
                    </NavLink>

                  </NavItem>
                  <UncontrolledTooltip target="#login-tooltip">
                    Inicia sesión
                  </UncontrolledTooltip>
                </>
                : <>
                  <UncontrolledDropdown nav>
                    <DropdownToggle
                      caret
                      color="default"
                      data-toggle="dropdown"
                      id="navbarDropdownMenuLink"
                      nav
                    >
                      {props.user.name}
                      <i
                        aria-hidden={true}
                        className="now-ui-icons users_circle-08"
                        title="Opciones"
                      />{ }
                    </DropdownToggle>
                    <DropdownMenu
                      aria-labelledby="navbarDropdownMenuLink"
                      right
                    >
                      <DropdownItem header>Opciones</DropdownItem>
                      {props.admin ?
                        <DropdownItem
                          onClick={event => handleClick(event, "options")}
                        >
                          Administración
                        </DropdownItem> :
                        <DropdownItem
                          onClick={event => handleClick(event, "options")}
                        >
                          Mis opciones
                        </DropdownItem>}
                      <DropdownItem
                        onClick={event => handleClick(event, "profile-page")}
                      >
                        Mi perfil
                      </DropdownItem>
                      <DropdownItem
                        onClick={event => handleClick2(event)}
                      >
                        Cerrar Sesión
                      </DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown></>}
            </Nav>
          </Collapse>
        </Container>
      </Navbar>
    </>
  );
}

export default ExamplesNavbar;